import { Swiper, SwiperSlide } from 'swiper/react';
import styled from 'styled-components';
import {
  Plane,
  Album,
  MapPinHouse,
  BriefcaseBusiness,
  Earth,
  ShieldCheck,
  MoveRight,
} from 'lucide-react';
import 'swiper/css';
import { useState, useEffect } from 'react';

export default function ServiceSection({ title }: { title: string }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cardColors = ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'];

  const blobColors = ['#ffffff', '#ffffff', '#ffffff', '#ffffff', '#ffffff'];

  const consultations = [
    'Immigration',
    'Scholarships',
    'Academics',
    'Wellness',
    'Mental Health',
    'Career Services',
  ];

  const icons = [
    Plane,
    Album,
    MapPinHouse,
    BriefcaseBusiness,
    Earth,
    ShieldCheck,
  ];

  return (
    <>
      <Container>
        <ContainerBox>
          <Heading className="manrope-semibold heading-color">
            {title}.
            <a href="#" className="manrope-regular">
              {/* <u>See all</u> &nbsp; <MoveRight color="#0952B3" /> */}
            </a>
          </Heading>
        </ContainerBox>
      </Container>
      {isMobile ? (
        <VerticalStack>
          {consultations.map((title, index) => {
            const cardColor = cardColors[index % cardColors.length];
            const blobColor = blobColors[index % blobColors.length];
            const IconComponent = icons[index % icons.length];

            return (
              <CounsellorCard
                key={index}
                className="clickable"
                $cardColor={cardColor}
                $blobColor={blobColor}
              >
                <div>
                  <div className="blob">
                    <IconComponent color="#ea5d0f" />
                  </div>
                  <h6 className="manrope-semibold">{title}</h6>
                </div>
              </CounsellorCard>
            );
          })}
        </VerticalStack>
      ) : (
        <Swiper
          slidesPerView={1}
          spaceBetween={1}
          breakpoints={{
            640: { slidesPerView: 4, spaceBetween: 20 },
            768: { slidesPerView: 4, spaceBetween: 20 },
            1024: { slidesPerView: 5, spaceBetween: 20 },
          }}
          className="mySwiperr"
        >
          {consultations.map((title, index) => {
            const cardColor = cardColors[index % cardColors.length];
            const blobColor = blobColors[index % blobColors.length];
            const IconComponent = icons[index % icons.length];

            return (
              <SwiperSlide key={index}>
                <CounsellorCard
                  className="clickable"
                  $cardColor={cardColor}
                  $blobColor={blobColor}
                >
                  <div>
                    <div className="blob">
                      <IconComponent color="#ea5d0f" />
                    </div>
                    <h6 className="manrope-semibold">{title}</h6>
                  </div>
                </CounsellorCard>
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
    </>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const ContainerBox = styled.div`
  width: 100%;
  max-width: 1155px;
  padding: 2.25px;
  display: flex;
  flex-wrap: wrap;
`;

const Heading = styled.h4`
  font-size: 1.4rem;
  margin: 1.25rem 0rem;
  display: flex;
  align-items: flex-end;
  a {
    font-size: 1rem;
    margin-left: 0.25rem;
    display: flex;
    align-items: center;
  }
`;

const CounsellorCard = styled.div<{ $cardColor: string; $blobColor: string }>`
  background-color: ${(props) => props.$cardColor};
  cursor: pointer;
  border-radius: 0.25rem;
  border: 1px solid #d3d3d3;
  overflow: hidden;
  min-height: 17rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 1rem;

  h6 {
    margin-top: 2rem;
    text-align: center;
    font-size: 1.35rem;
  }

  .blob {
    position: absolute;
    top: -100px;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${(props) => props.$blobColor};
    height: 200px;
    width: 200px;
    border-radius: 0.35rem;
    svg {
      margin-top: 5.5rem;
      height: 3.55rem;
      width: 3.55rem;
    }
  }
`;

const VerticalStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 0 1rem;
`;
